import { useConfirmDialogStore } from "@/shared/stores/confirm-dialog.store";
import { Button } from "@spz/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@spz/ui/components/dialog";
import { useTranslation } from "react-i18next";

export const ConfirmDialog = () => {
  const { t } = useTranslation();
  const { isOpen, title, description, onConfirm, closeDialog } =
    useConfirmDialogStore();

  return (
    <Dialog open={isOpen} onOpenChange={closeDialog}>
      <DialogContent title={title}>
        <DialogHeader title={title} description={description} />
        <DialogFooter>
          <Button variant="secondary" onClick={closeDialog}>
            {t("cancel")}
          </Button>
          <Button onClick={onConfirm}>{t("confirm")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
